<script setup>
import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
import PageLayout from 'dashboard/components-next/layout/PageLayout.vue';
import PageHeader from 'dashboard/components-next/layout/PageHeader.vue';
import AddAttribute from './AddAttribute.vue';
import CustomAttribute from './CustomAttribute.vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters, useStore } from 'dashboard/composables/store';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';

const { t } = useI18n();

const getters = useStoreGetters();
const store = useStore();

const showAddPopup = ref(false);
const selectedTabIndex = ref(0);
const uiFlags = computed(() => getters['attributes/getUIFlags'].value);

const hideAddPopup = () => {
  showAddPopup.value = false;
};

// Sidebar dispara este evento via createSidebarActionHandler.new-attribute.
const handleSidebarAttributeNew = () => {
  showAddPopup.value = true;
};

const tabs = computed(() => {
  return [
    {
      key: 0,
      name: t('ATTRIBUTES_MGMT.TABS.CONVERSATION'),
    },
    {
      key: 1,
      name: t('ATTRIBUTES_MGMT.TABS.CONTACT'),
    },
    {
      key: 2,
      name: t('ATTRIBUTES_MGMT.TABS.DEAL'),
    },
  ];
});

onMounted(() => {
  emitter.on(BUS_EVENTS.SIDEBAR_OPEN_ATTRIBUTE_NEW, handleSidebarAttributeNew);
  store.dispatch('attributes/get');
});

onBeforeUnmount(() => {
  emitter.off(BUS_EVENTS.SIDEBAR_OPEN_ATTRIBUTE_NEW, handleSidebarAttributeNew);
});

// Era um ternário de duas abas; com a terceira (negócio) virou mapa, senão
// qualquer aba diferente de 0 viraria "contato".
const MODEL_BY_TAB = [
  'conversation_attribute',
  'contact_attribute',
  'deal_attribute',
];
const attributeModel = computed(
  () => MODEL_BY_TAB[selectedTabIndex.value] || MODEL_BY_TAB[0]
);

const attributes = computed(() =>
  getters['attributes/getAttributesByModel'].value(attributeModel.value)
);

const onClickTabChange = index => {
  selectedTabIndex.value = index;
};
</script>

<template>
  <PageLayout>
    <template #header>
      <PageHeader
        icon="i-lucide-code"
        accent="gray"
        :title="$t('ATTRIBUTES_MGMT.HEADER')"
        :subtitle="$t('ATTRIBUTES_MGMT.DESCRIPTION')"
      />
    </template>
    <woot-tabs
      class="font-medium [&_ul]:p-0 mb-4"
      :index="selectedTabIndex"
      @change="onClickTabChange"
    >
      <woot-tabs-item
        v-for="(tab, index) in tabs"
        :key="tab.key"
        :index="index"
        :name="tab.name"
        :show-badge="false"
        is-compact
      />
    </woot-tabs>
    <woot-loading-state
      v-if="uiFlags.isFetching"
      :message="$t('ATTRIBUTES_MGMT.LOADING')"
    />
    <p
      v-else-if="!attributes.length"
      class="flex flex-col items-center justify-center h-full text-base text-n-slate-12 p-8"
    >
      {{ $t('ATTRIBUTES_MGMT.LIST.EMPTY_RESULT.404') }}
    </p>
    <CustomAttribute
      v-else
      :key="attributeModel"
      :attribute-model="attributeModel"
    />
    <AddAttribute
      v-if="showAddPopup"
      v-model:show="showAddPopup"
      :on-close="hideAddPopup"
      :selected-attribute-model-tab="selectedTabIndex"
    />
  </PageLayout>
</template>
